// extracted by mini-css-extract-plugin
export default {"App":"App_App__src1M","App-logo":"App_App-logo__VX46t","App-logo-spin":"App_App-logo-spin__ZI-l7","App-header":"App_App-header__E5Kwg","App-link":"App_App-link__sV3A6"};